import React from "react";
import service_four from "../images/debt-consolidation.webp";
import { useNavigate } from "react-router-dom";
import ChatButton from "../components/ChatButton";
import { APP_NAME } from "../Utils/constant";
import { handleApplyNow } from "../Utils/navigation";


const DebtConsolidation = () => {
  const navigate = useNavigate();
  return (
    <>
    
      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper">
          <div className="service_page_banner_wrapper_overlay">
            <h2>Debt Consolidation</h2>
          </div>

          <div className="text_content_wrapper">
            <div className="text_content">
              <div className="content_banner">
                <img src={service_four} alt="" />
              </div>
              <h1 className="page_title mt30 mb20">Debt Consolidation</h1>
              <p>
              {APP_NAME} provides a robust debt consolidation service aimed
                at simplifying your financial management and alleviating your
                debt load. By merging multiple debts into a single loan with a
                lower interest rate, we help you streamline monthly payments and
                potentially reduce interest expenses. Our knowledgeable advisors
                collaborate with you to develop a customized consolidation plan
                tailored to your financial situation and objectives, ensuring
                you regain control over your finances without the hassle of
                managing multiple payments.
              </p>
              <br />
              <p>
                In addition to reducing your financial stress, {APP_NAME}'s
                debt consolidation service offers transparent terms, allowing
                you to fully understand your new repayment plan. We strive to
                make the transition seamless, offering continuous support and
                guidance throughout the process. Our intuitive online platform
                enables you to monitor your progress and manage your account
                effortlessly. At {APP_NAME}, we are dedicated to helping you
                achieve financial stability and peace of mind through our
                effective debt consolidation solutions.
              </p>
              <br />
              <div className="button_container flex justify-center">
                <button onClick={() => handleApplyNow(navigate)} className="button_container Link">Apply Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default DebtConsolidation;
